import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ViewportScroller} from "@angular/common";
import {AktionService} from "../../service/aktion.service";
import {getAktionSearchCategories, IAktion} from "../../models/IAktion.interface";
import {FilterEngineService} from "../../service/filter-engine.service";
import {EventQueueService} from "../../service/event-queue-service.service";
import {AnmeldungStatus, Rolle} from "../../models/enums";
import {SessionService} from "../../service/session.service";
import {IActionButton} from "../../utils/filter/buttons";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {exportAktionen} from "../../utils/export/export";

function compareAktionen(a1:{start:number}, a2:{start:number}) {
  const now = Date.now()
  if (a1.start < now) {
    if (a2.start < now) {
      return a1.start - a2.start
    }
    return 1;
  }
  if (a2.start < now) {
    return -1;
  }
  return a1.start - a2.start
}

@Component({
  selector: 'app-aktions-list',
  templateUrl: './aktions-list.component.html',
  styleUrls: ['./aktions-list.component.scss']
})
export class AktionsListComponent implements OnInit, AfterViewInit {

  aktionen: IAktion[];
  query = "";
  categories = getAktionSearchCategories();
  isMa = false;
  actionButtons: IActionButton[] = [
    {
      mobile: false,
      title: "Alle Aktivieren",
      value: "<i class=\"fas fa-check-square\"></i>",
      callback: () => this.activateAll(),
      rolle: [Rolle.MA, Rolle.ADM]
    }, {
      mobile: false,
      title: "Alle Deaktivieren",
      value: "<i class=\"fas fa-square\"></i>",
      callback: () => this.deactivateAll(),
      rolle: [Rolle.MA, Rolle.ADM]
    }, {
      mobile: true,
      title: "Neue Veranstaltung",
      value: '<i class="fas fa-plus"></i>',
      callback: () => this.router.navigate(["/aktion/new"]),
      rolle: [Rolle.MA, Rolle.ADM]
    }, {
      mobile: false,
      title: "Import",
      value: '<i class="fas fa-file-import"></i>',
      callback: () => this.router.navigate(["/aktion/import"]),
      rolle: [Rolle.MA, Rolle.ADM]
    }, {
      mobile: false,
      title: "Export",
      value: '<i class="fas fa-file-export"></i>',
      callback: () => exportAktionen(this.aktionen),
      rolle: [Rolle.MA, Rolle.ADM]
    }
  ];

  constructor(
    private readonly aktionService: AktionService,
    private readonly filterService: FilterEngineService,
    private readonly eventQueue: EventQueueService,
    private readonly sessionService: SessionService,
    private readonly toastrService: ToastrService,
    private readonly router: Router
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.aktionen = (await this.filterService.filter(this.query,this.aktionService.getList(), "aktionenListInit")).sort(compareAktionen);
    this.isMa = this.sessionService.isMa();
    this.eventQueue.getObservable().subscribe(async msg=>{
      if(msg === "initDone"){
        this.aktionen = (await this.filterService.filter(this.query,this.aktionService.getList(), "aktionenListRefresh")).sort(compareAktionen);
        this.isMa = this.sessionService.isMa();
      }
    })
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const fragment = this.router.parseUrl(this.router.url).fragment;
      if (fragment) {
          const element = document.getElementById(fragment);
          if (element) {
            element.scrollIntoView({behavior: "auto", block: "start", inline: "nearest" });
          }
      }
    },100);
  }




  async updateFilter():Promise<void>{
    this.aktionen = (await this.filterService.filter(this.query,this.aktionService.getList(), "aktionenListInputChange")).sort(compareAktionen);

  }

  getClass(a: IAktion) {
    const max = a.maxKinder;
    const ist = a.anmeldungen.filter(an => an.status === AnmeldungStatus.GEBUCHT).length;

    const rel = ist / max;

    if(rel < 0.8) {
      return "green";
    }
    if(rel < 1) {
      return "yellow";
    }
    return "red";
  }

  aktionList(a: IAktion): {
    vor: number,
    ang: number,
    geb: number,
    wList: number,
    abGem: number,
  } {
    let vor = 0, ang = 0, geb = 0, wList = 0, abGem = 0;
    for(const an of a.anmeldungen) {
      switch (an.status) {
        case AnmeldungStatus.GEBUCHT:
          geb++; break;
        case AnmeldungStatus.VORANGEMELDET:
          vor++; break;
        case AnmeldungStatus.ANGEMELDET:
          ang++; break;
        case AnmeldungStatus.WARTELISTE:
          wList++; break;
        case AnmeldungStatus.ABGEMELDET:
          abGem++; break;
      }
    }

    return {
      vor,
      ang,
      geb,
      wList,
      abGem
    }
  }

  private activateAll() {
    this.setActiveAll(true)
  }

  private deactivateAll() {
    this.setActiveAll(false)
  }

  private async setActiveAll(aktiv: boolean) {
    try {
      const ret = await this.aktionService.setActiveAll(aktiv);
      if(ret.success) {
        this.toastrService.success(ret.error, "Erfolg");
      } else {
        this.toastrService.error(ret.error, "Fehler");
      }
    } catch (err) {
      this.toastrService.error(err?.error || err, "Fehler");
    }
  }
}
